{
  "seo": {
    "title": "Terms of Service",
    "description": "Read CuriPop's terms of service."
  },
  "title": "Terms of Service",
  "updated": "Last updated: {date}",
  "sections": {
    "agreement": {
      "title": "1. Agreement and Scope",
      "body1": "These Terms of Service form a legal agreement between you and CuriPop for use of the website, apps, and related services.",
      "body2": "If you do not agree to these terms, you may not access or use the service."
    },
    "accounts": {
      "title": "2. Accounts and Responsibility",
      "body1": "Parent, guardian, or educator accounts are responsible for child profiles created under them and for maintaining account security.",
      "body2": "You agree to provide accurate registration information, keep credentials confidential, and promptly notify us of unauthorized use."
    },
    "license": {
      "title": "3. License to Use CuriPop",
      "body1": "Subject to these terms, CuriPop grants you a limited, non-exclusive, non-transferable, revocable license to use the service for personal, family, or classroom educational use.",
      "body2": "This license does not permit resale, sublicensing, reverse engineering, or extraction of core content for commercial products."
    },
    "prohibited": {
      "title": "4. Prohibited Conduct",
      "lead": "You may not:",
      "items": [
        "Interfere with service operations, availability, or security.",
        "Bypass access controls, rate limits, or feature restrictions.",
        "Scrape, bulk-copy, or republish platform content without permission.",
        "Use the service for unlawful, abusive, or harmful purposes."
      ]
    },
    "disclaimer": {
      "title": "5. Educational Content Disclaimer",
      "body1": "CuriPop provides educational information for general learning. It is not a substitute for professional medical, legal, mental health, or emergency guidance.",
      "body2": "We strive for accuracy, but we do not warrant that all content will be complete, current, or free from error at all times."
    },
    "billing": {
      "title": "6. Paid Plans, Trials, and Billing",
      "body1": "Some features require a paid subscription. By subscribing, you authorize applicable recurring charges and agree to the pricing and billing cycle shown at checkout.",
      "body2": "Trial availability, plan limits, and pricing may change. We will provide notice where required by law."
    },
    "ip": {
      "title": "7. Intellectual Property",
      "body1": "The service, including software, design, logos, and content, is owned by CuriPop or its licensors and protected by intellectual property laws.",
      "body2": "Except as expressly permitted in these terms, no rights are granted to copy, modify, distribute, or create derivative works."
    },
    "termination": {
      "title": "8. Suspension and Termination",
      "body1": "We may suspend or terminate access if we determine there is a terms violation, security threat, fraud risk, or behavior harmful to users or the platform.",
      "body2": "You may stop using CuriPop at any time. To request account deletion, contact hello@curipop.com."
    },
    "warranty": {
      "title": "9. Warranty Disclaimer and Liability Limits",
      "body1": "CuriPop is provided on an \"as is\" and \"as available\" basis without warranties of any kind, to the maximum extent permitted by law.",
      "body2": "To the maximum extent permitted by law, CuriPop is not liable for indirect, incidental, special, consequential, or punitive damages arising from use of the service."
    },
    "governing": {
      "title": "10. Governing Law and Updates",
      "body1": "These terms are governed by applicable laws in the jurisdiction where CuriPop operates, without regard to conflict-of-law principles.",
      "body2": "We may revise these terms from time to time. Continued use after an update means you accept the revised terms."
    },
    "contact": {
      "title": "11. Contact",
      "body": "If you have questions about these Terms of Service, contact us at"
    }
  }
}
